import React from 'react';
import { Card, CardContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden/Hidden';
import { ArticleSkeleton } from 'common/ui/skeleton-ui';
import SectionTab from 'constants/SectionTab';
import { ItemList } from 'modules2/components';
import container from './LocationCard.container';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 345,
    background: theme.palette.paperColor,
    color: theme.palette.textColor,
  },
  listContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    marginTop: 10,
  },
  nextBtn: {
    color: '#ffffff',
    width: 300,
    fontWeight: 400,
    fontFamily: 'Arial',
    textTransform: 'uppercase',
    paddingTop: 10,
    marginBottom: 10,
    backgroundColor: theme.palette.buttonBackground,
    '&:hover': {
      backgroundColor: theme.palette.nextBtnHover,
    },
  },
}));

const LocationCard = (props) => {
  const classes = useStyles();
  const {
    siteCoordinator,
    stateList,
    radioPlayerState,
    onSetCurrentTab,
    onSetCurrentState,
  } = props;

  const onListItemClick = (tab, stateId) => {
    onSetCurrentTab(tab);
    onSetCurrentState(stateId);
  };

  const displayLocationList = (loading, num) => {
    if (loading) {
      return [...Array(num)].map((_, idx) => {
        return <ArticleSkeleton key={idx} />;
      });
    }

    return stateList.map((value, ind) => {
      return (
        <ItemList
          key={ind}
          id={value.id}
          name={value.name}
          sectionTab={SectionTab.Station}
          // radioList={radioPlayerState.radioList}
          onListItemClick={onListItemClick}
        />
      );
    });
  };

  return (
    <Card className={classes.root}>
      <CardContent style={{ padding: 0 }}>
        <Hidden xsDown>
          <div className={classes.listContainer}>
            {displayLocationList(false, 3)}
          </div>
        </Hidden>
        <Hidden smUp>
          <div className={classes.listContainer}>
            {displayLocationList(false, 1)}
          </div>
        </Hidden>
      </CardContent>
    </Card>
  );
};

export default container(LocationCard);
